module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "merchandise"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("商品管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), (_vm.state) ? _c('div', {
    staticClass: "panel-body tip"
  }, [(_vm.uploadInfo.no_error) ? _c('p', {
    staticClass: "color-green"
  }, [_vm._v("成功上传 " + _vm._s(_vm.uploadInfo.success) + " 件商品")]) : _c('div', [_c('p', {
    staticClass: "color-red"
  }, [_vm._v("共发现 " + _vm._s(_vm.uploadInfo.fails) + " 条错误数据")]), _vm._v(" "), _c('a', {
    staticClass: "banner-btn",
    attrs: {
      "href": _vm.downloadUrl,
      "download": ""
    }
  }, [_c('i', {
    staticClass: "icon-download"
  }), _vm._v(" "), _c('span', {
    staticClass: "banner-btn__desc"
  }, [_vm._v("下载错误数据")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.uploadLoading),
      expression: "uploadLoading"
    }],
    staticClass: "upload-demo",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "show-file-list": false,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "drag": "",
      "action": _vm.uploadUrl,
      "accept": "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "multiple": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("请将填写完成的模板文件拖放到此区域,或"), _c('em', [_vm._v("点击上传")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "myform_wrapper"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.merchantData.list,
      "row-class-name": "el-table__row_fix"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "id",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.img) ? _c('img', {
          attrs: {
            "src": scope.row.img,
            "alt": "",
            "width": "44",
            "height": "44"
          }
        }) : _c('el-button', {
          attrs: {
            "id": 'img-id-' + scope.row.id,
            "size": "small",
            "type": "primary"
          }
        }, [_vm._v("上传图片")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "min-width": "150",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: [scope.row.available === 1 ? 'color-green' : 'color-orange']
        }, [_vm._v(_vm._s(scope.row.available_str))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品类",
      "prop": "cate_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品类状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: [scope.row.cate_available === 1 ? 'color-green' : 'color-orange']
        }, [_vm._v(_vm._s(scope.row.cate_available_str))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.merchantData.count >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.merchantData.count,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("上传引导")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body steps"
  }, [_c('div', [_c('p', {
    staticClass: "step"
  }, [_vm._v("step"), _c('span', [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "step-text"
  }, [_vm._v("下载批量导入数据所用的 Excel 模板")]), _vm._v(" "), _c('a', {
    staticClass: "banner-btn",
    attrs: {
      "href": "https://sh-hk.qfapi.com/static/excel/example.xlsx",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "icon-download"
  }), _vm._v(" "), _c('span', {
    staticClass: "banner-btn__desc"
  }, [_vm._v("下载模板")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "step"
  }, [_vm._v("step"), _c('span', [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "step-text"
  }, [_vm._v("仔细阅读模版中说明，按照模版要求填写完模版后，将模板文件拖入下方上传区域")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "step"
  }, [_vm._v("step"), _c('span', [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "step-text"
  }, [_vm._v("如模版中有错误数据导致导入失败，请下载错误数据，修改后重新上传")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "step"
  }, [_vm._v("step"), _c('span', [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "step-text"
  }, [_vm._v("上传成功的菜品将显示在下面的列表中，点击图片可更换这些图片")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cdd1a33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/merchandise/merchandise.vue
// module id = 817
// module chunks = 1